import { Directive, EventEmitter, Input, Output } from "@angular/core";
@Directive()
export abstract class AbstractButtonComponent {

    @Input() label: string;

    @Input() disabled: boolean;

    @Input() cssClass: string;

    @Input() critical: boolean;

    @Output() buttonClick = new EventEmitter<void>();

}